import { useNavigate } from 'react-router-dom'

import ArrowLeftIcon from 'assets/icons/ArrowLeft.png'
import ArrowIcon from 'assets/icons/ArrowRight.png'
import { Button } from 'components/Button'

import { ProjectSetUpTabs } from './ProjectSetUpTabs'
import './projectSetUp.scss'

export const ProjectSetUp = () => {
  const navigate = useNavigate()

  return (
    <div className="project-setup mx-auto flex flex-col items-center gap-10">
      <h1 className="headline-xl text-center">Project Set-Up</h1>

      <ProjectSetUpTabs />

      <div className="flex justify-center gap-4">
        <Button
          text="Go to Brand Assessment"
          color="white"
          className="px-[16px] py-[10px] border-2 z-[2]"
          iconposition="left"
          icon={<img src={ArrowLeftIcon} alt="Arrow Left" width="16" height="16" />}
          onClick={() => navigate('/process?Brand Assessment')}
        />
        <Button
          text="Go to Working Mode Selection"
          color="black"
          className="px-[16px] py-[10px] z-[2]"
          iconposition="right"
          icon={<img src={ArrowIcon} alt="Arrow" width="16" height="16" />}
          onClick={() => navigate('/process?Working Mode Selection')}
        />
      </div>
    </div>
  )
}
